import * as React from 'react';
import { ISize } from '@uifabric/utilities/lib/ISize';
import { WithItemCache, IItemCacheStateProps } from '../withItemCache/WithItemCache';
import { itemThumbnailControl } from '../../controls/itemThumbnailControl';
import { css } from '@uifabric/utilities/lib/css';
import * as ItemThumbnailStyles from './ItemThumbnail.scss';
import { thumbnailFacet } from '../../facets/MediaFacets';

export interface IOnThumbnailLoadProps { }
export interface IOnThumbnailErrorProps { }

export interface IItemThumbnailProps {
  className?: string;
  itemKey: string;
  desiredSize: ISize;
  onLoad?: (props: IOnThumbnailLoadProps) => void;
  onError?: (props: IOnThumbnailErrorProps) => void;
}

export class ItemThumbnail extends React.PureComponent<IItemThumbnailProps> {
  public render(): JSX.Element {
    const {
      itemKey,
      desiredSize,
      onLoad,
      onError,
      className
    } = this.props;

    return (
      <WithItemCache>
        { ({ itemCache }: IItemCacheStateProps) => {
          const isThumbnailResolved = itemCache.isItemFacetResolved(thumbnailFacet, itemKey);
          const image = isThumbnailResolved ? itemCache.demandItemFacet(thumbnailFacet, itemKey) : undefined;

          if (isThumbnailResolved && !image) {
            return null;
          }

          const controlHandler = itemCache.demandItemFacet(itemThumbnailControl, itemKey);

          const {
            thumbnail
          } = itemThumbnailControl.evaluate(controlHandler)(itemCache, {
            itemKey: itemKey,
            originalImage: image,
            desiredSize: desiredSize,
            thumbnail: image
          });

          if (!thumbnail || !thumbnail.url) {
            return null;
          }

          return (
            <img
              className={ css(ItemThumbnailStyles.image, className) }
              src={ thumbnail.url }
              onLoad={ onLoad }
              onError={ onError }
            />
          );
        } }
      </WithItemCache>
    );
  }
}
